export class Country {
    createdBy: string;
    createdDate: string;
    id: string =null;
    inactive: boolean = false;
    iso3Code: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    localizableEntryId: string;
    name: string;
    timeStamp: string;

    constructor() { }
}